import Media from "react-bootstrap/Media";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useState, useEffect, useContext } from "react";
import { campaignFetcher, commentsFetcher } from "../../api/requests";
import Cookies from "js-cookie";
import { useHistory } from "react-router-dom";
import { ProfileContext } from "../../context/profile";
import { baseURL } from "../../api/dataFetcher";
import { useLocation } from "react-router-dom";

export default function CommentMedia({
  commentAuthor,
  timeAgo,
  commentBody,
  image,
  replies,
  commentId,
  id,
}) {
  const [showReplyInput, setShowReplyInput] = useState(false);
  const [reply, setReply] = useState("");
  const { profile } = useContext(ProfileContext);
  const [message, setMessage] = useState("");
  const location = useLocation();
  const campaignId = new URLSearchParams(location.search).get("campaign");
  const [moreText, setMoreText] = useState(false);
  const [replyLoading, setReplyLoading] = useState(false);

  const handleReplyChange = (e) => {
    setReply(e.target.value);
  };

  const handleReplySubmit = async () => {
    setReplyLoading(true);
    try {
      const res = campaignId
        ? await campaignFetcher.postCampaignComments({
            comment: reply,
            video_post: id,
            user: profile.user,
            uper_comment: commentId,
          })
        : await commentsFetcher.post({
            comment: reply,
            video_post: id,
            user: profile.user,
            uper_comment: commentId,
          });

      if (res) {
        setMessage("نظر شما بعد از تایید نمایش داده خواهد شد.");
      } else {
        setMessage("نظر شما بعد از تایید نمایش داده خواهد شد.");
      }
    } catch (err) {
      console.error(err);
      setMessage("نظر شما بعد از تایید نمایش داده خواهد شد.");
    } finally {
      setReplyLoading(false);
    }

    setReply("");
    setShowReplyInput(false);
  };

  useEffect(() => {
    if (message !== "") {
      const timer = setTimeout(() => {
        setMessage("");
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [message]);

  return (
    <>
      <div className="reviews-members">
        <Media>
          <a href="#">
            <img
              className="ml-3"
              src={image ? baseURL + image : "/img/s1.png"}
              alt=""
            />
          </a>
          <Media.Body>
            <div className="media-body">
              <div className="reviews-members-header">
                <h6 className="mb-1">
                  <a className="text-black" href="#">
                    {commentAuthor}{" "}
                  </a>{" "}
                  <small className="text-gray">{timeAgo}</small>
                </h6>
              </div>
              <div className="reviews-members-body">
                {commentBody.length > 600 ? (
                  <p style={{ whiteSpace: "pre-line" }}>
                    {moreText ? (
                      <>
                        {commentBody}{" "}
                        <small
                          style={{
                            backgroundColor: "whitesmoke",
                            padding: "2px 5px",
                            borderRadius: "7px",
                            display: "inline-block",
                            fontWeight: "bold",
                            cursor: "pointer",
                          }}
                          onClick={() => setMoreText(false)}
                        >
                          مشاهده کمتر
                        </small>
                      </>
                    ) : (
                      <>
                        {commentBody.slice(0, 450) + "... "}
                        <small
                          style={{
                            backgroundColor: "whitesmoke",
                            padding: "2px 5px",
                            borderRadius: "7px",
                            display: "inline-block",
                            fontWeight: "bold",
                            cursor: "pointer",
                          }}
                          onClick={() => setMoreText(true)}
                        >
                          مشاهده بیشتر
                        </small>
                      </>
                    )}
                  </p>
                ) : (
                  <p style={{ whiteSpace: "pre-line" }}>{commentBody}</p>
                )}

                <span
                  // variant="link "
                  style={{ cursor: "pointer" }}
                  size="sm"
                  onClick={() => setShowReplyInput(!showReplyInput)}
                >
                  پاسخ
                </span>
                {showReplyInput && (
                  <Form.Control
                    style={{ marginBottom: "5px" }}
                    as="textarea"
                    rows={1}
                    value={reply}
                    placeholder="نظر خود را ثبت کنید..."
                    onChange={handleReplyChange}
                  />
                )}
                {showReplyInput && (
                  <Button 
                    variant="info" 
                    size="sm" 
                    onClick={handleReplySubmit}
                    disabled={replyLoading}
                  >
                    {replyLoading ? "در حال ارسال..." : "ارسال"}
                  </Button>
                )}
                {message && (
                  <p style={{ marginTop: "10px", color: "#28a745", fontSize: "14px" }}>
                    {message}
                  </p>
                )}
              </div>
            </div>
          </Media.Body>
        </Media>

        {replies?.length > 0 &&
          replies?.map((item, index) => (
            <Media style={{ margin: "15px 55px 0px 0px" }} key={index}>
              <a href="#">
                <img
                  className="ml-3"
                  src={
                    item?.user?.image
                      ? baseURL + item?.user?.image
                      : "/img/s1.png"
                  }
                  alt=""
                />
              </a>
              <Media.Body>
                <div className="media-body">
                  <div className="reviews-members-header">
                    <h6 className="mb-1">
                      <a className="text-black" href="#">
                        {item?.user?.first_name + " " + item?.user?.last_name}{" "}
                      </a>{" "}
                      <small className="text-gray">{item?.created_date}</small>
                    </h6>
                  </div>
                  <div className="reviews-members-body">
                    {item?.comment?.length > 600 ? (
                      <p style={{ whiteSpace: "pre-line" }}>
                        {moreText ? (
                          <>
                            {item?.comment}{" "}
                            <small
                              style={{
                                backgroundColor: "whitesmoke",
                                padding: "2px 5px",
                                borderRadius: "7px",
                                display: "inline-block",
                                fontWeight: "bold",
                                cursor: "pointer",
                              }}
                              onClick={() => setMoreText(false)}
                            >
                              مشاهده کمتر
                            </small>
                          </>
                        ) : (
                          <>
                            {item?.comment.slice(0, 450) + "... "}
                            <small
                              style={{
                                backgroundColor: "whitesmoke",
                                padding: "2px 5px",
                                borderRadius: "7px",
                                display: "inline-block",
                                fontWeight: "bold",
                                cursor: "pointer",
                              }}
                              onClick={() => setMoreText(true)}
                            >
                              مشاهده بیشتر
                            </small>
                          </>
                        )}
                      </p>
                    ) : (
                      <p style={{ whiteSpace: "pre-line" }}>{item?.comment}</p>
                    )}
                  </div>
                </div>
              </Media.Body>
            </Media>
          ))}
      </div>
    </>
  );
}

function CustomMedia({ commentCount, profile, id }) {
  const [comment, setComment] = useState();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const history = useHistory();
  const location = useLocation();
  const campaignId = new URLSearchParams(location.search).get("campaign");

  const handleCommentChange = (e) => {
    setComment(e.target.value);
  };

  const handleCancel = () => {
    setComment("");
  };

  const handleSendClick = async () => {
    const cookieUser = Cookies.get("vaghfnamaUser");
    if (!cookieUser) {
      history.push("/auth/login");
      return;
    }

    setLoading(true);
    try {
      const res = campaignId
        ? await campaignFetcher.postCampaignComments({
            comment: comment,
            video_post: id,
            user: profile.user,
            uper_comment: null,
          })
        : await commentsFetcher.post({
            comment: comment,
            video_post: id,
            user: profile.user,
            uper_comment: null,
          });

      if (res) {
        setLoading(false);
        setMessage("نظر شما پس تایید نمایش داده خواهد شد.");
      } else {
        setLoading(false);
      }
    } catch (err) {
      console.error(err);
      setLoading(false);
      setMessage("نظر شما پس تایید نمایش داده خواهد شد.");
    }

    setComment("");
  };

  useEffect(() => {
    if (message !== "") {
      const timer = setTimeout(() => {
        setMessage("");
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [message]);

  return (
    <>
      <div className="reviews-members pt-0">
        <Media>
          <a href="#">
            <img
              className="ml-3"
              src={profile.image ? baseURL + profile.image : "/img/s1.png"}
              alt=""
            />
          </a>
          <Media.Body>
            <div className="form-members-body">
              <Form.Control
                as="textarea"
                rows={1}
                value={comment}
                placeholder="نظر خود را ثبت کنید..."
                onChange={handleCommentChange}
              />
            </div>

            <div className="form-members-footer text-right mt-2">
              <b className="float-left">{commentCount} نظر</b>
              <Button variant="outline-info" size="sm" onClick={handleCancel}>
                لغو
              </Button>
              &nbsp;
              <Button
                style={{ cursor: loading ? "wait" : "pointer" }}
                variant="info"
                size="sm"
                onClick={handleSendClick}
              >
                {loading ? "لطفا منتظر بمانید..." : "ارسال"}
              </Button>
              {message && <p className="mt-2">{message}</p>}
            </div>
          </Media.Body>
        </Media>
      </div>
    </>
  );
}

export { CustomMedia, CommentMedia };
